import { render, staticRenderFns } from "./GovernmentEnterprise.vue?vue&type=template&id=9810d4fe&scoped=true"
import script from "./GovernmentEnterprise.vue?vue&type=script&lang=js"
export * from "./GovernmentEnterprise.vue?vue&type=script&lang=js"
import style0 from "./GovernmentEnterprise.vue?vue&type=style&index=0&id=9810d4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9810d4fe",
  null
  
)

export default component.exports